import React from 'react';
import { colors } from '../../../../../../../../../../../colorVars';
import { BoxInput } from '../../../../../../../../../../atomic/inputs/boxInput/BoxInput';
import {
  Body3,
  fontSizes,
} from '../../../../../../../../../../atomic/text/Text';
import { CandlePatternButton } from './CandlePatternButton';
import { sequenceMap } from './candlePatternMap';
import { CandlePatternSequenceBox } from './CandlePatternSequenceBox';
import style from './CandlePatternSetupModule.module.css';
import { v4 as uuidv4 } from 'uuid';
import TextButton from '../../../../../../../../../../atomic/buttons/textButton/TextButton';
import { observer } from 'mobx-react-lite';
import { useAlertFormStore } from '../../../../../alertFormClass';

export const CandlePatternSetupModule = observer(() => {
  const form = useAlertFormStore();
  return (
    <div className={`${style.container} noDragTag`}>
      <header className={style.header}>
        <Body3 fontWeight={700} color={colors.lightGrey}>
          Candle Pattern
        </Body3>
      </header>
      <div className={style.body}>
        <div className={style.inputs}>
          <div className={style.inputAndLabel}>
            <Body3 fontWeight={700} color={colors.lightGrey}>
              Candle Duration
            </Body3>
            <BoxInput
              value={form.setupDetails['CANDLE_PATTERN'].candleDuration}
              setValue={(value) =>
                form.setupDetails['CANDLE_PATTERN'].setCandleDuration(value)
              }
              backgroundColor={colors.grey}
              fontSize={fontSizes.body3}
              width="50px"
              height="20px"
              direction="right"
              symbol="m"
            />
          </div>
        </div>
      </div>
      <div className={style.buttonContainer}>
        {Object.keys(sequenceMap).map((sequence) => {
          const label = sequenceMap[sequence];
          return (
            <CandlePatternButton
              key={sequence}
              fontSize={fontSizes.body3}
              label={label}
              clickHandler={() => {
                const length =
                  form.setupDetails['CANDLE_PATTERN'].currentPattern.length;
                if (length === 0) {
                  form.setupDetails['CANDLE_PATTERN'].clearPatternArray();
                  form.setupDetails[
                    'CANDLE_PATTERN'
                  ].addSequenceToCurrentPattern({
                    terminateOnFail: false,
                    restartOnFail: false,
                    candleSequence: sequence,
                  });

                  form.setupDetails['CANDLE_PATTERN'].addPatternToArray();
                } else {
                  form.setupDetails['CANDLE_PATTERN'].clearPatternArray();

                  form.setupDetails[
                    'CANDLE_PATTERN'
                  ].addSequenceToCurrentPattern({
                    terminateOnFail: false,
                    restartOnFail: true,
                    candleSequence: sequence,
                  });

                  form.setupDetails['CANDLE_PATTERN'].addPatternToArray();
                }
              }}
            />
          );
        })}
      </div>
      <div className={style.patternContainer}>
        <div className={style.patternBox}>
          {form.setupDetails['CANDLE_PATTERN'].pattern[0]?.map(
            (sequence, index) => {
              const length = form.setupDetails['CANDLE_PATTERN'].pattern.length;
              const key = uuidv4();
              return (
                <CandlePatternSequenceBox
                  length={length}
                  index={index}
                  sequence={sequence}
                  key={key}
                />
              );
            }
          )}
        </div>
        <TextButton
          backgroundColor={colors.blue}
          fontSize="small"
          clickHandler={() => {
            form.setupDetails['CANDLE_PATTERN'].clearCurrentPattern();
            form.setupDetails['CANDLE_PATTERN'].clearPatternArray();
          }}
        >
          Clear Pattern
        </TextButton>
      </div>
    </div>
  );
});
